export default __webpack_public_path__ + "static/media/windows.e970ec67.svg";